import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormFields } from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';
import { Select } from '../../../../../CommonComponents/OPL/Select/Select/Select';
import { InsuranceDTO } from '../../../api/useInsuranceQuery';

interface Props {
  data: InsuranceDTO;
}

export const LifeInsurancePolicyTerm = ({ data }: Props) => {
  const formBag = useFormContext<FormFields>();

  const options = data.Options.LifeInsuranceTermOptions.map(opt => ({
    value: opt,
    label: opt,
  }));

  return (
    <Controller
      control={formBag.control}
      name="LifeInsurancePolicyTerm"
      render={({ field: { value, onChange } }) => {
        return (
          <Select
            label="Term"
            value={options.find(opt => opt.value === value)}
            options={options}
            onChange={opt => onChange(opt?.value)}
            isPortal
          />
        );
      }}
    />
  );
};
